import { ENVIRONMENTS } from '@/utils/constants'

export const ATOMIC_CUSTOMER_APIS = [
  process.env.VUE_APP_SANDBOX_ATOMIC_CUSTOMER_API,
  process.env.VUE_APP_PRODUCTION_ATOMIC_CUSTOMER_API,
]

// Default endpoint for the local Customer API. Used by the optional `local`
// environment when `VUE_APP_LOCAL_ATOMIC_CUSTOMER_API` isn't set, so the
// Publish → Local option Just Works for the standard local backend port.
const DEFAULT_LOCAL_ATOMIC_CUSTOMER_API = 'http://localhost:3002'

export function getAtomicCustomerAPIFromEnvironment(environment) {
  if (environment === ENVIRONMENTS.LOCAL) {
    return process.env.VUE_APP_LOCAL_ATOMIC_CUSTOMER_API || DEFAULT_LOCAL_ATOMIC_CUSTOMER_API
  }

  return environment === ENVIRONMENTS.PRODUCTION
    ? process.env.VUE_APP_PRODUCTION_ATOMIC_CUSTOMER_API
    : process.env.VUE_APP_SANDBOX_ATOMIC_CUSTOMER_API
}
